import { useState, useEffect } from "react";
import { MessageCircle, X } from "lucide-react";

// Floating WhatsApp chat button — real ValueDrive WhatsApp number from valuedriveauto.co.uk
const WA_NUMBER = "447979210250";
const WA_MESSAGE = encodeURIComponent("Hi ValueDrive! I'd like to ask about a tyre/service.");

const WhatsAppButton = () => {
  const [open, setOpen] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 1200);
    return () => clearTimeout(t);
  }, []);

  if (!visible) return null;

  return (
    <>
      {open && (
        <div
          className="fixed bottom-24 right-6 w-72 vd-card p-4 z-[60] shadow-2xl"
          style={{ animation: "vdFadeUp 0.25s ease" }}
          data-testid="whatsapp-popover"
        >
          <div className="flex items-start justify-between gap-2 mb-2">
            <p className="vd-heading font-bold">Chat on WhatsApp</p>
            <button onClick={() => setOpen(false)} aria-label="Close" className="vd-muted hover:text-[var(--primary-red)]"><X size={18} /></button>
          </div>
          <p className="vd-body text-sm mb-3">Got a question about tyres or mobile fitting? Message us on WhatsApp — typical reply in under 5 minutes.</p>
          <a
            href={`https://wa.me/${WA_NUMBER}?text=${WA_MESSAGE}`}
            target="_blank"
            rel="noopener noreferrer"
            className="vd-btn-primary w-full justify-center"
            style={{ background: "#25D366", borderColor: "#25D366" }}
            data-testid="whatsapp-start-chat"
          >
            <MessageCircle size={18} /> Start Chat
          </a>
          <p className="vd-muted text-xs text-center mt-3">+44 7979 210250</p>
        </div>
      )}

      <button
        onClick={() => setOpen((v) => !v)}
        aria-label="Open WhatsApp chat"
        data-testid="whatsapp-fab"
        className="fixed bottom-6 right-6 z-[60] flex items-center justify-center rounded-full shadow-2xl transition-transform hover:scale-110"
        style={{ width: 60, height: 60, background: "#25D366", color: "#fff", animation: "vdPulse 2s ease-in-out infinite" }}
      >
        <MessageCircle size={28} strokeWidth={2} />
      </button>

      <style>{`
        @keyframes vdPulse {
          0%, 100% { box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.5); }
          50% { box-shadow: 0 0 0 14px rgba(37, 211, 102, 0); }
        }
        @keyframes vdFadeUp {
          from { opacity: 0; transform: translateY(8px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </>
  );
};

export default WhatsAppButton;
